import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

import { safeRedirect } from '@/shared/lib'

import { LoginPage } from '@/features/auth'

import { AuthPending } from '@/app/layouts'
import { sessionQuery } from '@/app/router/session'

/** `returnTo` comes from the URL, so it is validated before it is ever used. */
const loginSearchSchema = z.object({
  returnTo: z.string().optional().catch(undefined),
})

export const Route = createFileRoute('/_public/login')({
  validateSearch: loginSearchSchema,
  beforeLoad: async ({ context, search }) => {
    const session = await context.queryClient.ensureQueryData(sessionQuery()).catch(() => null)

    // Never show a sign-in wall to someone already through it — a stale
    // bookmark to /login would otherwise strand them here.
    if (session !== null) {
      // Absolute URLs are rejected; otherwise this is an open redirect.
      throw redirect({ href: safeRedirect(search.returnTo), replace: true })
    }
  },
  pendingComponent: AuthPending,
  component: LoginPage,
})
